import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import './FloatingActionButtonHolder.css';

const FloatingActionButtonHolder = ({ children }) => {
  return (
    <Box
      className="fab-holder"
      sx={{
        position: 'fixed',
        bottom: 25,
        right: 25,
        zIndex: 21,
      }}
    >
      {children}
    </Box>
  );
};

FloatingActionButtonHolder.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FloatingActionButtonHolder;
